import React from 'react'

const StrongCustom: React.FC = ({children}) => {
  return (
    <strong style={{width: "100%"}}> {children} </strong>
  )
}

export default StrongCustom